<script>
    import {createEventDispatcher} from "svelte";
    import {eventBus} from "../core/event-bus-store.js";
    import {t} from "../core/i18n/language-store.js";
    const dispatch = createEventDispatcher();

    export let record;
    export let priceItem;   
    export let priceIndex;
    export let publishConfig;
    export let spaceBetween = false;
    export let size = 'm'; // m, lg

    const addToCartHandler = (record) => {

        /// multiline price and priceIndex is provided
        if (priceIndex !== undefined && (record?.mods || []).length === 0) {
            dispatch('add');
            return;
        }

        /// no variants nor mods
        if (record?.prices?.length === 1 && record?.mods?.length === 0) {
            dispatch('add');
            return;
        }
         
        /// has multiple price variants or mods
        eventBus.set([{event: 'openEditDetailsHalfScreen', payload: {record, mode: 'addItems'}}]);
    };

    const removeFromCartHandler = (record) => {

        /// no mods and multiline price and priceIndex is provided
        if (priceIndex !== undefined && (record?.mods || []).length === 0) {
            dispatch('remove');
            return;
        }

        /// no variants nor mods
        if (record?.prices?.length === 1 && record?.mods?.length === 0) {
            dispatch('remove');
            return;
        }

        /// has multiple price variants or mods
        eventBus.set([{event: 'openEditDetailsHalfScreen', payload: {record, mode: 'removeItems'}}]);
    };

</script>
<style>

.price-block {
    display: inline-flex;
    justify-content: end;
    align-items: center;
}
.price {
    font-family: PT Mono, sans-serif;
    color: var(--accent-color);
    font-size: 16px;
    font-weight: 600;
}
.price--lg {
    font-size: 24px;
}
.price--old {
    color: var(--accent-color);
    text-decoration: line-through;
    font-family: PT Mono, sans-serif;
    font-size: .9em;
    opacity: .5;
    padding-right: .25em;
}
.from {
    color: var(--secondary-font-color);
}
</style>

<span class="price-block nowrap full-width" class:flex-between={spaceBetween} class:ai-center={spaceBetween}>

    <span>
        {#if priceItem.oldPrice }
            <span class="price--old">
                {priceItem.oldPrice}
            </span>
        {/if}

        <span class="price" class:price--lg={size === 'lg'}>
            <span class="price-pair" class:price-pair--rev={publishConfig?.currency === '$'}>
                <span>{ priceItem.price || '-' }</span>
                <span>{ publishConfig?.currency || '' }</span>
            </span>
        </span>
    </span>

    {#if (publishConfig.disableCart !== true)}
        <span class="order-buttons" style="margin-left: 0.5em;">
            {#if ( (priceItem?._count || 0) > 0)}
            <!-- {#if ( (record?._orderedItems || 0) > 0)} -->
                <button class="add-button pointer" on:click|stopPropagation={removeFromCartHandler(record)}>-</button>
                <span class="counter">{priceItem?._count}</span>
            {/if}
            <button class="add-button pointer" on:click|stopPropagation={addToCartHandler(record)}>+</button>
        </span>
    {/if}
</span>
